import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as app from '../actions/app';
import RequestForm from '../components/requestForm/';


export default connect(
  state => ({
    loading: state.app.requestLoading,
    requestError: state.app.requestError,
    userTimezoneOffset: state.app.userTimezoneOffset,
  }),
  dispatch => bindActionCreators(({
    onStartChat: app.startChat
  }), dispatch)
)(RequestForm);



// WEBPACK FOOTER //
// ./containers/RequestForm.js